import * as authTypes from './authTypes';

export const login = (data, resolve, reject) => ({
  type: authTypes.LOGIN,
  data,
  resolve,
  reject,
});

export const logout = () => ({ type: authTypes.LOGOUT });

export const restoreSession = () => ({ type: authTypes.RESTORE_SESSION });

export const setAuthStaff = (staff) => ({ type: authTypes.SET_AUTH_STAFF, staff });

export const sendOtp = (email, resolve, reject) => ({
  type: authTypes.SEND_OTP_REQUEST,
  payload: { email, resolve, reject },
});

export const loginWithOtp = (data, resolve, reject) => ({
  type: authTypes.LOGIN_WITH_OTP_REQUEST,
  payload: { data, resolve, reject },
});


export const getClinicRequest = (token, resolve, reject) => ({
  type: authTypes.GET_CLINIC_REQUEST,
  payload: { token, resolve, reject }
})
export const getClinicSuccess = (data) => ({
  type: authTypes.GET_CLINIC_SUCCESS,
  payload: { data }
})
export const getClinicFailure = (error) => ({
  type: authTypes.GET_CLINIC_FAILURE,
  payload: { error }
})

export const setSelectedClinic = (clinic) => ({
  type: authTypes.SET_SELECTED_CLINIC,
  payload: clinic,
});


